import { ArrowUpRight } from "lucide-react";
import { useLang } from "../i18n/LanguageContext";

export default function Services() {
  const { t } = useLang();
  return (
    <section
      id="services"
      data-testid="services-section"
      className="relative py-24 md:py-40 border-b border-[#1a1a1a]"
    >
      <div className="max-w-[1440px] mx-auto px-6 md:px-12">
        <div className="grid grid-cols-1 lg:grid-cols-12 gap-8 mb-16 md:mb-24">
          <div className="lg:col-span-4">
            <div className="flex items-center gap-4 mb-6">
              <span className="font-mono text-[11px] uppercase tracking-[0.3em] text-[#ff4500]">
                {t.services.label}
              </span>
              <span className="h-[1px] w-16 bg-[#262626]" />
            </div>
            <h2
              data-testid="services-heading"
              className="font-serif text-4xl md:text-5xl lg:text-6xl font-light leading-[1.05] tracking-tight"
            >
              {t.services.headingA}{" "}
              <span className="italic text-[#ff4500]">{t.services.headingB}</span>.
            </h2>
          </div>
          <div className="lg:col-span-5 lg:col-start-8 flex items-end">
            <p className="text-neutral-400 text-base md:text-lg leading-relaxed">
              {t.services.intro}
            </p>
          </div>
        </div>

        <div className="border-t border-[#1a1a1a]">
          {t.services.items.map((s) => (
            <a
              key={s.num}
              href="#contact"
              data-testid={`service-row-${s.num}`}
              onClick={(e) => {
                e.preventDefault();
                document.querySelector("#contact")?.scrollIntoView({ behavior: "smooth" });
              }}
              className="group grid grid-cols-12 gap-4 md:gap-8 items-start py-8 md:py-10 border-b border-[#1a1a1a] hover:bg-[#0f0f0f] transition-colors duration-300 px-2"
            >
              <div className="col-span-2 md:col-span-1 font-mono text-xs text-neutral-500 pt-2">
                {s.num}
              </div>
              <div className="col-span-10 md:col-span-4">
                <h3 className="font-serif text-2xl md:text-4xl font-light tracking-tight group-hover:text-[#ff4500] transition-colors duration-300">
                  {s.title}
                </h3>
              </div>
              <div className="col-span-12 md:col-span-5 md:col-start-6 text-neutral-400 text-sm md:text-base leading-relaxed">
                {s.desc}
              </div>
              <div className="col-span-10 md:col-span-1 md:col-start-11 flex flex-wrap gap-2 md:justify-end">
                {s.tags.map((tag) => (
                  <span
                    key={tag}
                    className="font-mono text-[10px] uppercase tracking-wider text-neutral-500 border border-[#1a1a1a] px-2 py-1"
                  >
                    {tag}
                  </span>
                ))}
              </div>
              <div className="col-span-2 md:col-span-1 md:col-start-12 flex md:justify-end pt-2">
                <ArrowUpRight
                  size={22}
                  className="text-neutral-600 group-hover:text-[#ff4500] group-hover:translate-x-1 group-hover:-translate-y-1 transition-all duration-300"
                />
              </div>
            </a>
          ))}
        </div>
      </div>
    </section>
  );
}
